import ButtonSubmitAgreement from './ButtonSubmitAgreement';

export default ButtonSubmitAgreement;
